import { Box, Checkbox, Typography } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import cash from 'assets/img/svg/cash.svg'
import bankcard from 'assets/img/svg/bankcard.svg'
import banktransfer from 'assets/img/svg/banktransfer.svg'
import reachafrikapayment from 'assets/img/svg/reachafrikapayment.svg'
import pos from 'assets/img/svg/pos.svg'
import useSWR from 'swr'
import { apiRequest } from 'store/Misc/apiRequest'
import Spinner from 'components/Spinner'

function PaymentMethod() {
    const { data: merchant } = useSWR('/merchants/me')
    const [modes, setModes] = useState({ available: [], active: [] })
    const [watchChange, setWatchChange] = useState(false)

    const getModes = useCallback(async () => {
        if (merchant) {
            const available = await apiRequest({ method: 'get', url: `settings/payment-modes/${merchant.data.id}/available` })
            const active = await apiRequest({ method: 'get', url: `settings/payment-modes/${merchant.data.id}/active` })
            // available.data.map((x,i) => [x.id,x.id])
            return { available: available.data, active: active.data }
        }
        return { available: [], active: [] }
    }, [merchant])
    useEffect(() => {
        const fetchMods = async () => {
            const { available, active } = await getModes()
            setModes({ available, active })
        }
        fetchMods()
        console.log(watchChange)
    }, [getModes,watchChange])

    const change = async (e) => {
        
        setWatchChange(!watchChange)
        const { name: id, checked } = e.target
        // console.log(id, value, checked)
        await apiRequest({
            method: checked ? 'put' : 'delete', url: `/settings/payment-modes/${merchant.data.id}/${id}`
        })


    }
    const images = [cash, bankcard, banktransfer, reachafrikapayment, pos]
    return (
        <div className='bg-white p-2 rounded-[12px] p-5'>
            <Typography className='text-[30px] font-bold text-[#657585]'>Payment Method</Typography>
            <div className='text-[#657585]'>Choose payment methods you wish to use</div>
            <div className='py-5 flex flex-col ' >
                { modes.available.length ?
                    modes?.available?.map((X, i) => {
                        return (<div className='flex  items-center h-[70px] border-b w-100 px-5'>
                            <Box sx={{ width: '50%', display: 'flex', gap: '25px', color: '#05213D', fontSize: '24px' }}>
                                <img src={images[i]} alt={''} /> <div>{X.name}  </div>
                            </Box> <Checkbox className='block' name={X.id}
                                checked={modes.active.find(x => X.id === x.id)?.id ? true : false}
                                value={modes.active.find(x => X.id === x.id)}
                                onChange={change}
                            />
                        </div>)
                    })
                    :
                    <Spinner />
                }
            </div>
        </div>
    )
}

export default PaymentMethod